import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ModalController, LoadingController } from '@ionic/angular';
import { AuthService } from '../../../../../services/auth.service';
import { ExternalApiSettingsService } from '../../../../../services/dal/external-api-settings.service';
import { ToastService } from '../../../../../services/toast.service';
import { BrewfatherExternalService } from '../../../../../services/external/brewfather.service';
import { IBrewfather } from '../../../../../models/brewfather';
import { IBeverage } from '../../../../../models/beverage';
import { BeverageService } from '../../../../../services/dal/beverage.service';
import { BeerstyleService } from '../../../../../services/dal/beerstyle.service';
import { IBeerStyle } from '../../../../../models/beerstyle';
import { SubscriptionHandler } from '../../../../../services/subscriptionHandler.service';
import { Observable, Subscription } from 'rxjs';
import { IBar } from 'app/models/bar';
import { Store } from '@ngrx/store';
import * as fromUser from 'app/state/user/reducer'
import * as fromExternalApiSettings from 'app/state/external-api-settings/reducer'
import { IExternalApiSettings } from 'app/models/externalApiSettings';
import { RouterTestingHarness } from '@angular/router/testing';
import * as fromSubscription from "app/state/subscription/reducer";
import * as fromBeerStyle from "app/state/beer-style/reducer";
import * as BeerstyleActions from "app/state/beer-style/actions";
import { ColorHelper } from 'app/services/color.helper';

@Component({
  selector: 'app-search-brewfather',
  templateUrl: './search-brewfather.page.html',
  styleUrls: ['./search-brewfather.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule]
})
export class SearchBrewfatherPage implements OnInit, OnDestroy {

  @Input() beer!: IBeverage;

  public filteredItems: any[] = [];
  public loading!: HTMLIonLoadingElement;
  public items: any = [];
  private brewfather!: IBrewfather;
  public searchName = '';
  private barId!: string;
  public batchStatus!: string;
  subs: Subscription[] = [];
  isPremium$!: Observable<boolean>;
  externalApiSettings$!: Observable<IExternalApiSettings | undefined>;
  beerStyles$!: Observable<IBeerStyle[]>;


  constructor(
    private modalController: ModalController,
    private loadingController: LoadingController,
    private colorHelper: ColorHelper,
    private authService: AuthService,
    private externalApiSettingsService: ExternalApiSettingsService,
    private beverageService: BeverageService,
    private beerStyleService: BeerstyleService,
    private brewfatherExternalService: BrewfatherExternalService,
    private toastService: ToastService,
    private sh: SubscriptionHandler,
    private store: Store
  ) { }

  ngOnInit() {
    //    this.barId$ = this.store.select(fromUser.selectBarId);
    this.isPremium$ = this.store.select(fromSubscription.getHasPremium);
    this.externalApiSettings$ = this.store.select(fromExternalApiSettings.selectItem);
    this.beerStyles$ = this.store.select(fromBeerStyle.getAllItems);

    // const auth$ = this.authService.user$.subscribe(async user => {
    //   if (user != null) {
    //     this.barId = await this.authService.selectUserBarId();
    //     //this.getContent(this.barId);
    //   }
    // });
    // this.subs.push(auth$);
    // this.sh.addSubscription(auth$);
  }
  ngOnDestroy() {
    for (let index = 0; index < this.subs.length; index++) {
      const sub = this.subs[index];
      if (sub) { sub.unsubscribe(); }
    }
  }


  dismiss(beerStyles: IBeerStyle[] | null, settings: IExternalApiSettings | null, bfItem: any) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data

    if (!bfItem) {
      this.modalController.dismiss();
      return;
    }
    const brewfather = settings?.brewfather;

    this.showLoading();
    const brewfather$ = this.brewfatherExternalService.getBatch(brewfather, bfItem._id).then(async result => {
      this.hideLoading();
      try {
        const item = JSON.parse(result.data);

        const beerStyleName = item.recipe.style == null ? 'Default' : item.recipe.style.name ? item.recipe.style.name : item.recipe.style.category;

        let beerStyle = beerStyles?.find(x => x.name === beerStyleName);
        if (!beerStyle) {

          let newBeerStyle: IBeerStyle = {
            barId: this.barId,
            name: beerStyleName,
          };
          beerStyle = { ...newBeerStyle };
          //this.store.dispatch(BeerstyleActions.addItem({item: newBeerStyle}));
        }


        this.beer.name = item.name === 'Batch' ? item.recipe.name : item.name;
        this.beer.abv = item.measuredAbv;
        this.beer.fg = item.measuredFg ?? item.estimatedFg ?? 1;
        this.beer.bottleDate = item.bottlingDate ? item.bottlingDate : this.beer.bottleDate;
        this.beer.ibu = item.recipe.ibu ? item.recipe.ibu : this.beer.ibu;

        this.beer.srm = item.recipe.color ? item.recipe.color : this.beer.srm;
        if (this.beer.srm) {
          this.beer.color = this.colorHelper.convertSrmToWebColor(this.beer.srm);
        }

        this.beer.beerStyle = beerStyle as IBeerStyle;

        this.modalController.dismiss({
          beer: this.beer
        });





      } catch (error) {
        console.error('error', error);

        this.toastService.error('Unable to get batch, check settings for Brewfather and try again.');
      }

    });


  }


  filterItem(value: string) {
    if (!value) {
      this.assignCopy();
    } // when nothing has typed
    this.filteredItems = Object.assign([], this.items).filter(
      (item: any) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
  }


  assignCopy() {
    this.filteredItems = Object.assign([], this.items);
  }

  private async findBeerStyle(name: string) {

    const beerstyles = await this.beerStyleService.findStyle(this.barId, name);
    if (beerstyles && beerstyles.length > 0) {
      return beerstyles[0] as IBeerStyle;
    } else {
      const beerStyle: IBeerStyle = {
        barId: this.barId,
        name
      };

      const result$ = this.beerStyleService.add(beerStyle);

      result$.catch(err => {
        console.error('err', err);
      });

      return await result$;

    }

  }
  //   private getContent(barId) {
  //     const item$ = this.externalApiSettingsService.getItem(barId);
  //     const itemsub$ = item$.subscribe(result => {
  //       const item = result;

  //       if (item.brewfather == null) {
  //         this.toastService.error('Brewfather not defined, check under settings.');
  //         return;
  //       }
  //       this.brewfather = item.brewfather;
  //       if(this.batchStatus){
  //         this.getBatches(0);
  //       }
  //     });
  //     this.subs.push(itemsub$);
  //     this.sh.addSubscription(itemsub$);
  //   }

  getBatchesFromStatus(settings: IExternalApiSettings, status: string) {
    this.batchStatus = status;
    if (settings.brewfather) {
      this.getBatches(settings.brewfather, '');
    }
  }

  getBatches(brewfather: IBrewfather, offset: string) {
    this.showLoading();
    if (!offset) {
      this.items = [];
    }
    const limit = 10;
    const bfExt$ = this.brewfatherExternalService.getBatchesPaged(brewfather, offset, limit, this.batchStatus).then(result => {
      this.hideLoading();

      try {
        const items = JSON.parse(result.data);
        items.forEach((element: any) => {
          if (!this.items.find((x: any) => x._id === element._id)) {
            this.items.push(element);
          }
        });
        if (items.length > 0) {
          var offset = items[items.length - 1]._id;
          this.getBatches(brewfather, offset);
        } else {
          this.assignCopy();
        }
      } catch (error) {
        this.toastService.error('Unable to get batches, check settings for Brewfather and try again.');
      }

    });
  }


  async showLoading(): Promise<void> {
    try {
      this.hideLoading().then(() => {
        return this.loadingController.create().then(loading => {
          this.loading = loading;
          return this.loading.present();
        });
      });

    } catch (error: any) {
      this.toastService.error(error);
    }
  }

  hideLoading(): Promise<boolean | null> {
    if (this.loading) {
      return this.loading.dismiss().then(() => null);
    }
    return Promise.resolve(null);
  }
}
